<template>
  <div v-if="action" class="custom-modal-overlay">
    <div class="custom-modal">
      <!-- Tombol close pakai simbol × -->
      <button
        v-if="$listeners.close"
        class="close-btn"
        @click="$emit('close')"
        aria-label="Tutup modal"
      >
        &times;
      </button>

      <div class="custom-modal-icon">
        <span v-if="action === 'success'" class="icon success">✔</span>
        <span v-else-if="action === 'error'" class="icon error">✖</span>
      </div>

      <div class="custom-modal-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomModal',
  props: {
    action: {
      type: String,
      default: null,
      validator: value => ['success', 'error', null].includes(value)
    }
  }
}
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 73, 144, 0.6); /* Biru transparan */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.custom-modal {
  position: relative;
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background: none;
  border: none;
  font-size: 2rem;
  color: #004990;
  cursor: pointer;
  line-height: 1;
}
.close-btn:hover {
  color: #002f61;
}

.custom-modal-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.icon.success {
  color: #28a745;
}

.icon.error {
  color: #dc3545;
}

.custom-btn {
  background-color: white;
  color: #004990;
  border: 1px solid #004990;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s ease;
}

.custom-btn:hover {
  background-color: #004990;
  color: white;
}

@keyframes pop-in {
  0% {
    transform: scale(0.2);
    opacity: 0;
  }
  60% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

.icon.success {
  color: #28a745;
  animation: pop-in 0.5s ease-out;
}

.icon.error {
  color: #dc3545;
  animation: shake 0.4s ease-in-out;
}

@keyframes shake {
  0% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  50% { transform: translateX(4px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}
</style>


// WEBPACK FOOTER //
// src/components/CustomModal.vue